import React from 'react';
import Dashboard from './Dashboard';
import ReservationList from './ReservationList';

const MyReservations = () => (
  <div className="wrapper">
    <Dashboard />
    <ReservationList />
  </div>
);

export default MyReservations;
